<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">系统设置</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>活期宝设置</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div class="search-wrap">
      <el-select v-model="searchData.coinType" filterable placeholder="请选择(可搜索)">
        <el-option
          v-for="item in ['所有'].concat(coinList)"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-date-picker type="date" placeholder="起始时间" v-model="searchData.startTime" class="mr"></el-date-picker>
      <el-date-picker type="date" placeholder="结束时间" v-model="searchData.endTime" class="mr"></el-date-picker>
      <el-button type="primary" @click="search()" class="mr">搜索</el-button>
    </div>
    <div class="page-actions">
      <create-current></create-current>
    </div>
    <current-list @refresh="refreshList"></current-list>
  </el-card>
</div>
</template>

<script>
import './store';
import CurrentList from './components/list';
import CreateCurrent from './components/create';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CurrentSetting',
  data() {
    return {
      searchData: {}
    }
  },
  components: {
    CurrentList,
    CreateCurrent
  },
  methods: {
    ...mapActions('currentSetting', ['getCoinList', 'list']),
    search() {
      this.list(this.searchData);
    },
    refreshList(data = {}) {
      this.list({
        ...this.searchData,
        ...data
      });
    }
  },
  computed: {
    ...mapState('currentSetting', ['coinList', 'contentTypeList'])
  },
  created() {
    this.getCoinList();
    this.list(this.searchData);
  }
};
</script>

<style lang="less" scoped>
.search-wrap {
  margin-bottom: 20px;
}
.mr {
  margin-left: 20px;
}
</style>
